module.exports = __webpack_public_path__ + "img/zichanfuzhai.76a8cc93.png";